var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSearchIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21.1592 17.102L19.2229 15.1633C18.8153 14.7551 18.2038 14.7551 17.7962 15.1633C17.3885 15.5714 17.3885 16.1837 17.7962 16.5918L19.7325 18.5306C20.0382 18.8367 20.0382 19.3469 19.7325 19.6531C19.4268 19.9592 18.9172 19.9592 18.6115 19.6531L15.5541 16.5918C15.758 16.3878 15.9618 16.2857 16.1656 16.0816C17.6943 14.551 18.6115 12.4082 18.6115 10.2653C18.6115 8.02041 17.7962 5.97959 16.1656 4.44898C12.9045 1.18367 7.70701 1.18367 4.44586 4.44898C1.18471 7.71429 1.18471 12.9184 4.44586 16.1837C5.97452 17.7143 8.11465 18.6327 10.2548 18.6327C11.4777 18.6327 12.7006 18.3265 13.7197 17.8163L17.0828 21.1837C17.5924 21.6939 18.4076 22 19.121 22C19.8344 22 20.5478 21.6939 21.1592 21.1837C22.2803 19.9592 22.2803 18.1224 21.1592 17.102ZM5.87261 14.551C3.42675 12.102 3.42675 8.12245 5.87261 5.77551C7.09554 4.55102 8.6242 3.93878 10.2548 3.93878C11.8854 3.93878 13.414 4.55102 14.6369 5.77551C15.8599 7 16.4713 8.53061 16.4713 10.1633C16.4713 11.7959 15.8599 13.4286 14.6369 14.551C13.414 15.6735 11.8854 16.3878 10.2548 16.3878C8.6242 16.3878 6.99363 15.7755 5.87261 14.551Z",
    fill: "#808080"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSearchIcon);
export default __webpack_public_path__ + "static/media/search-icon.2f6470cdda28ad2dd97e026163ba917a.svg";
export { ForwardRef as ReactComponent };